export const FILTER_ACTIONS = {
  REMOVE_FILTER_ARRAY: 'REMOVE_FILTER_ARRAY',
  SELECT_FILTER: 'SELECT_FILTER',
  REMOVE_FILTER: 'REMOVE_FILTER',
  REMOVE_ALL_FILTERS: 'REMOVE_ALL_FILTERS',
  APPLY_FILTER: 'APPLY_FILTER',
  INITIALIZE_CYCLES: 'INITIALIZE_CYCLES',
  FETCH_CPT: 'FETCH_CPT'
};

export const FILTER_KEYS = {
  CYCLES: 'cycles',
  CPT: 'CPT',
  LEG: 'leg',
  START_PDD: 'startPDD',
  END_PDD: 'endPDD',
  LAST_UPDATED_START: 'lastUpdatedStart',
  LAST_UPDATED_END: 'lastUpdatedEnd',
  SHIP_DATE_START: 'shipDateStart',
  SHIP_DATE_END: 'shipDateEnd',
  DWELL_END: 'dwellEnd',
  DWELL_START: 'dwellStart',
  PACKAGE_TYPES: 'packageTypes',
  PACKAGE_TYPES_REVERSE: 'packageTypes_Reverse',
  PACKAGE_STATUSES: 'packageStatuses',
  DELIVERY_WINDOW: 'deliveryWindow',
  SAME_DAY: 'sameDay',
  STATION_ARRIVAL_TIME: 'stationArrivalTime'
};

export const FILTER_VALUES = {
  FORWARD: 'Forward',
  REVERSE: 'Reverse'
};

export const TAG_LABELS = {
  EAD_FROM: 'EAD From : ',
  EAD_TO: 'EAD To : ',
  SHIP_DATE_FROM: 'Ship Date From : ',
  SHIP_DATE_TO: 'Ship Date To : ',
  LAST_UPDATED_FROM: 'Last Updated From : ',
  LAST_UPDATED_TO: 'Last Updated To : ',
  SAME_DAY: 'Same Day'
};

export const FORMATTED_MESSAGE_IDS = {
  FILTERS_PREFIX: 'filters.',
  COMMONS_PREFIX: 'commons.',
  CPT_PREFIX: 'CPT.',
  FORWARD: 'forward',
  REVERSE: 'reverse',
  LEG: 'leg',
  CYCLE: 'cycle',
  STATION_ARRIVAL_TIME: 'station_arrival_time',
  ESTIMATED_ARRIVAL_DATE: 'estimated_arrival_date',
  SHIPMENT_TYPE: 'shipment_type',
  PACKAGE_STATUS: 'package_status',
  SELECT_PACKAGE_STATE: 'select_package_state',
  MINUTES_IN_STATE: 'minutes_in_state',
  FROM_DWELL: 'from_dwell',
  TO_DWELL: 'to_dwell',
  LAST_UPDATED_DATE: 'last_updated_date',
  SHIP_DATE: 'ship_date',
  SEARCH: 'search',
  CLEAR_ALL: 'clear_all',
  SAME_DAY: 'same_day',
  SCHEDULED_DELIVERY_WINDOW: 'scheduled_delivery_window'
};

export const TOASTER_MESSAGES = {
  DWELL_TIME_ERROR: 'From should be less than To in Minutes in State'
};

export const MISC_CONSTANTS = {
  SPACE_STRING: '\xa0\xa0\xa0\xa0\xa0',
  PACKAGE_SEARCH_PATH: 'packageSearch'
};


// WEBPACK FOOTER //
// ./src/commons/constants/FilterConstants.js